const Publish = ({ isNeedPublish }: any) => {
  return (
    <div className="d-flex justify-content-center align-items-center p-5">
      <div
        className={`p-4 rounded-4 shadow-sm text-center border ${
          isNeedPublish ? "border-info bg-light" : "border-warning bg-light"
        }`}
        style={{ maxWidth: "500px", width: "100%" }}
      >
        <div className="mb-3 fs-1">
          <i
            className={`bi ${
              isNeedPublish ? "bi-exclamation-circle-fill text-info" : "bi-info-circle-fill text-warning"
            }`}
          ></i>
        </div>
        <h5 className={isNeedPublish ? "text-info" : "text-warning"}>
          {isNeedPublish
            ? "Pending changes to be published."
            : "Please make changes before publishing."}
        </h5>
        <p className="text-muted small mt-2">
          {isNeedPublish
            ? "You have unsaved edits. Click 'Publish' to make them live."
            : "Make any edits to your chatbot settings to enable publishing."}
        </p>
      </div>
    </div>
  );
};

export default Publish;
